function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from '../../../comun/services/acceso-datos';
var TarjetaPregBloqueComponentCtrl = /*#__PURE__*/function () {
  TarjetaPregBloqueComponentCtrl.$inject = ["$log", "NotifService", "AccesoDatos"];
  function TarjetaPregBloqueComponentCtrl($log, NotifService, AccesoDatos) {
    _classCallCheck(this, TarjetaPregBloqueComponentCtrl);
    _defineProperty(this, "editando", false);
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(TarjetaPregBloqueComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[TarjetaPregBloqueComponentCtrl] onInit');
    }
  }, {
    key: "editPreguntaFormulario",
    value: function editPreguntaFormulario() {
      this.editando = true;
    }
  }, {
    key: "toggleVisiblePreguntaFormulario",
    value: function toggleVisiblePreguntaFormulario() {
      this.pregbloque.toggleVisible();
    }
  }, {
    key: "toggleEliminarPreguntaFormulario",
    value: function toggleEliminarPreguntaFormulario() {
      this.pregbloque.toggleEliminar();
    }
  }, {
    key: "downPregFormulario",
    value: function downPregFormulario() {
      this.bloque.bajarPreg(this.idx);
    }
  }, {
    key: "upPregFormulario",
    value: function upPregFormulario() {
      this.bloque.subirPreg(this.idx);
    }
  }, {
    key: "nuevaOpcion",
    value: function nuevaOpcion() {
      this.pregbloque.options.push('');
    }
  }, {
    key: "splitOpcion",
    value: function splitOpcion(idx) {
      this.pregbloque.options.splice(idx, 1);
    }
  }]);
}();
angular.module('candidato').component('tarjetaPregBloque', {
  bindings: {
    pregbloque: '<',
    bloque: '<',
    idx: '<'
  },
  controller: TarjetaPregBloqueComponentCtrl,
  template: require('./tarjeta-preg-bloque.component.html')
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/tarjeta-preg-bloque/tarjeta-preg-bloque.component.html"
});